import React, { useEffect } from "react"
import { navigate } from "gatsby"
import { connect } from "react-redux"
import Intro from "./Intro"
import IntroSection from "./IntroSection"
import BackButton from "./BackButton"
import Activity from "./Activity"
import Question from "./Question"
import Results from "./Results"
import StartupName from "./StartupName"
import { canViewStep, getLastReachedStep } from "./helpers/steps"

const Step = ({ basepath, lastReachedStep, retake, step, type }) => {
  useEffect(() => {
    redirectIfTooFar()
  }, []) // eslint-disable-line

  useEffect(() => {
    redirectIfTooFar()
  }, [step]) // eslint-disable-line

  const redirectIfTooFar = () => {
    if (canViewStep(step, lastReachedStep)) return
    navigate(`${basepath}`, { replace: true })
  }

  const props = { basepath, lastReachedStep, retake, step, type }
  let component

  // need to do this check here also for server side rendering
  if (canViewStep(step, lastReachedStep) !== true) return null

  if (step === 0) {
    component = <Intro {...props} />
  } else if (step === 1) {
    component = <StartupName {...props} />
  } else if (step === 2) {
    component = <Activity {...props} />
  } else if (step === 3) {
    component = <IntroSection {...props} id={2} />
  } else if (step >= 4 && step <= 11) {
    component = <Question {...props} id={step - 3} />
  } else if (step === 12) {
    component = <IntroSection {...props} id={3} />
  } else if (step >= 13 && step <= 15) {
    component = <Question {...props} id={step - 4} />
  } else if (step === 16) {
    component = <Results {...props} />
  } else {
    return null
  }

  if (step >= 1) {
    return (
      <>
        <BackButton {...props} />
        {component}
      </>
    )
  } else return component
}

export default connect(({ questionnaire }) => {
  const lastReachedStep = getLastReachedStep(questionnaire)
  return { lastReachedStep }
})(Step)
